const PropertyLoader = () => {
  return (
    <div className="animate-pulse mt-5">
      {/* Overview — 3 column */}
      <div className="flex gap-4">
        {/* Left: Occupancy + Sqft */}
        <div className="w-[22%] flex flex-col gap-4">
          <div className="bg-white rounded-xl p-4">
            <div className="h-4 bg-gray-200 rounded w-2/3 mb-4"></div>
            <div className="w-[120px] h-[120px] bg-gray-200 rounded-full mx-auto mb-4"></div>
            <div className="flex justify-between pt-3 border-t border-gray-100">
              <div className="flex flex-col items-center gap-1">
                <div className="h-4 bg-gray-200 rounded w-8"></div>
                <div className="h-3 bg-gray-100 rounded w-10"></div>
              </div>
              <div className="flex flex-col items-center gap-1">
                <div className="h-4 bg-gray-200 rounded w-8"></div>
                <div className="h-3 bg-gray-100 rounded w-10"></div>
              </div>
              <div className="flex flex-col items-center gap-1">
                <div className="h-4 bg-gray-200 rounded w-8"></div>
                <div className="h-3 bg-gray-100 rounded w-10"></div>
              </div>
            </div>
          </div>
          <div className="bg-white rounded-xl p-4">
            <div className="h-4 bg-gray-200 rounded w-1/2 mb-2"></div>
            <div className="h-3 bg-gray-100 rounded w-2/3 mb-2"></div>
            <div className="h-7 bg-gray-200 rounded w-3/4 mb-3"></div>
            <div className="h-2 bg-gray-200 rounded-full w-full mb-3"></div>
            <div className="flex justify-between">
              <div className="h-3 bg-gray-200 rounded w-14"></div>
              <div className="h-3 bg-gray-200 rounded w-14"></div>
            </div>
          </div>
        </div>

        {/* Center: Image */}
        <div className="w-[44%]">
          <div className="bg-gray-200 rounded-xl h-[400px]"></div>
        </div>

        {/* Right: Info cards */}
        <div className="w-[34%] flex flex-col gap-4">
          <div className="bg-white rounded-xl p-4">
            <div className="h-4 bg-gray-200 rounded w-1/2 mb-3"></div>
            <div className="h-3 bg-gray-100 rounded w-full mb-1"></div>
            <div className="h-3 bg-gray-100 rounded w-3/4"></div>
          </div>
          <div className="bg-white rounded-xl p-4">
            <div className="h-4 bg-gray-200 rounded w-2/3 mb-3"></div>
            <div className="h-8 bg-gray-200 rounded w-1/2"></div>
          </div>
          <div className="bg-white rounded-xl p-4">
            <div className="h-4 bg-gray-200 rounded w-1/3 mb-2"></div>
            <div className="h-[140px] bg-gray-200 rounded-lg"></div>
          </div>
          <div className="bg-white rounded-xl p-4">
            <div className="h-4 bg-gray-200 rounded w-1/3 mb-3"></div>
            {[1, 2, 3].map((i) => (
              <div key={i} className="flex justify-between items-center border-b border-gray-50 py-2">
                <div>
                  <div className="h-3 bg-gray-200 rounded w-24 mb-1"></div>
                  <div className="h-2 bg-gray-100 rounded w-16"></div>
                </div>
                <div className="h-3 bg-gray-200 rounded w-12"></div>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Units */}
      <div className="mt-5 bg-white rounded-xl p-5">
        <div className="h-5 bg-gray-200 rounded w-24 mb-4"></div>
        <div className="flex flex-wrap gap-3">
          {[1, 2, 3, 4].map((i) => (
            <div key={i} className="bg-gray-100 rounded-lg w-[49%] h-24"></div>
          ))}
        </div>
      </div>

      {/* Maintenance + Payments */}
      <div className="flex justify-between mt-5 gap-4">
        <div className="w-[49%] bg-white rounded-lg px-3 py-5">
          {[1, 2, 3, 4, 5].map((i) => (
            <div key={i} className="h-10 bg-gray-200 rounded w-full mb-3"></div>
          ))}
        </div>
        <div className="w-[49%] bg-white rounded-lg px-3 py-5">
          {[1, 2, 3, 4, 5].map((i) => (
            <div key={i} className="h-10 bg-gray-200 rounded w-full mb-3"></div>
          ))}
        </div>
      </div>

      {/* Lease table */}
      <div className="bg-white rounded-lg px-3 py-5 mt-5">
        {[1, 2, 3, 4, 5].map((i) => (
          <div key={i} className="h-10 bg-gray-200 rounded w-full mb-3"></div>
        ))}
      </div>
    </div>
  );
};

export default PropertyLoader;
